import { AppSettings } from '../configs';
import { authHeader } from '../helpers/auth-header';
import axios  from "../utils/axios";

const ContractMomService={

    getAttachments: (transaction_no) => {
        return new Promise((resolve, reject) => {
            axios({
              headers: {...authHeader(),'Pragma': 'no-cache'},
              method: "post",
              url: `${AppSettings.apiUrl}/api/MR/GetAttachments/${transaction_no}`,
              data: {}
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error))
          })
      },
      confirmDeleleMom: (data) => {
        return new Promise((resolve, reject) => {
            axios({
              headers: {...authHeader(),'Pragma': 'no-cache'},
              method: "post",
              url: `${AppSettings.apiUrl}/api/RRS/ConfirmDeleleMom`,
              data: data
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error))
          })
      },
      checkCanDeleleMom: (transaction_no) => {
        return new Promise((resolve, reject) => {
            axios({
              headers: {...authHeader(),'Pragma': 'no-cache'},
              method: "post",
              url: `${AppSettings.apiUrl}/api/RRS/CheckCanDeleleMom/${transaction_no}`,
              data: {}
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error))
          })
      }

      
};


export default ContractMomService;